import { Component, computed, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatBadgeModule } from '@angular/material/badge';
import { CartService } from '../services/cart.service';
import { ActivatedRoute, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { TranslateModule } from '@ngx-translate/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Subject, filter, takeUntil } from 'rxjs';
import { EventData, EventInteractionService } from '@mare-common/ngx-mare-common';
import { CommonConfig } from '../shared/common-config/common-config';

@Component({
  selector: 'ngx-shopping-cart',
  standalone: true,
  imports: [CommonModule,
    MatButtonModule,
    MatBadgeModule,
    TranslateModule,
    MatTooltipModule],
  templateUrl: './shopping-cart.component.html',
  styleUrls: ['./shopping-cart.component.scss']
})
export class ShoppingCartComponent {
  unsubscribe$: Subject<any> = new Subject();
  enableShoppingCart!: boolean

  constructor(
    private router: Router,
    private cartService: CartService,
    private eventInteractionService: EventInteractionService,
    private commonConfig: CommonConfig) {

    // router.events.pipe(
    //   filter((event) => event instanceof NavigationEnd),
    //   takeUntil(this.unsubscribe$)
    // ).subscribe((ev:any) => {
    //   console.log('url__________',ev.url)
    // })
    this.enableShoppingCart = commonConfig.getFromConfig('enableShoppingCart', false);
    this.eventInteractionService.getObservable().subscribe((data: EventData) => {
     
      switch (data.event) {
        case 'addToCart':
        case 'removeFromCart':
        case 'emptyCart':
         
          this.initCart();
          break;
        case 'cartPageEnter':
          this.isCartPage$.set(true);
          break;
        case 'cartPageLeave':
            this.isCartPage$.set(false);
            break;
        default:
          break;
      }
    })
  }
  cartItems$ = signal([]);
  isCartPage$ = signal(false)
  cartActive$ = computed(() => {
    return this.cartItems$().length > 0 && !this.isCartPage$();
  })


  ngOnInit(): void {
    if(this.enableShoppingCart) {
      this.initCart();
    }
  }
  initCart() {
    this.cartService.getCart().then((res: any) => {
      this.cartItems$.set(res)
      
    })
  }
  goTocheckout() {
    let basePath = environment.routingBasePath;
    this.router.navigate([basePath + '/cart']);

  }
  // initSubscriptionCart() {
  //   // todo recuperare lo stato del carrello dal cart.service e iniziare la subscription del carrello
  //   this.router.events.pipe(
  //     filter((event) => event instanceof NavigationEnd),
  //     takeUntil(this.unsubscribe$)
  //   ).subscribe((ev: any) => {
  //     if (ev.url.indexOf('cart') > -1) {
  //       this.unsubscribe$.unsubscribe();
  //       this.cartActive$.set(false);
  //     } else {
  //       this.cartActive$.set(true);
  //     }
  //   })
  // }

  ngOndestroy(): void {
    this.unsubscribe$.unsubscribe();
  }
}
